"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_VARIANT_TYPES = exports.tableBodyStripedCustomOdd = exports.tableBodyStripedCustomEven = exports.tableBodyStripedCustomEvenOdd = exports.tableBodyStripedDefault = exports.tableBody = void 0;

var _stylitas = require("@creditas/stylitas");

const TABLE_VARIANT_TYPES = {
  default: 'default',
  striped: 'striped'
};
exports.TABLE_VARIANT_TYPES = TABLE_VARIANT_TYPES;

const tableBody = () => (0, _stylitas.css)`
  margin: 0 10px;
`;

exports.tableBody = tableBody;

const tableBodyStripedDefault = ({
  variant,
  stripedColorEven,
  stripedColorOdd,
  theme
}) => {
  return variant === TABLE_VARIANT_TYPES.striped && !stripedColorEven && !stripedColorOdd && (0, _stylitas.css)`
      tr:nth-of-type(even) {
        background-color: ${_stylitas.utilities.palette.color(theme, 'neutral00')};
      }

      tr:nth-of-type(odd) {
        background-color: ${_stylitas.utilities.palette.color(theme, 'neutral02')};
      }
    `;
};

exports.tableBodyStripedDefault = tableBodyStripedDefault;

const tableBodyStripedCustomEvenOdd = ({
  variant,
  stripedColorEven,
  stripedColorOdd,
  theme
}) => variant === TABLE_VARIANT_TYPES.striped && stripedColorEven && stripedColorOdd && (0, _stylitas.css)`
    tr:nth-of-type(even) {
      background-color: ${_stylitas.utilities.palette.color(theme, stripedColorEven)};
    }

    tr:nth-of-type(odd) {
      background-color: ${_stylitas.utilities.palette.color(theme, stripedColorOdd)};
    }
  `;

exports.tableBodyStripedCustomEvenOdd = tableBodyStripedCustomEvenOdd;

const tableBodyStripedCustomEven = ({
  variant,
  stripedColorEven,
  stripedColorOdd,
  theme
}) => variant === TABLE_VARIANT_TYPES.striped && stripedColorEven && !stripedColorOdd && (0, _stylitas.css)`
    tr:nth-of-type(even) {
      background-color: ${_stylitas.utilities.palette.color(theme, stripedColorEven)};
    }

    tr:nth-of-type(odd) {
      background-color: ${_stylitas.utilities.palette.color(theme, 'neutral01')};
    }
  `;

exports.tableBodyStripedCustomEven = tableBodyStripedCustomEven;

const tableBodyStripedCustomOdd = ({
  variant,
  stripedColorEven,
  stripedColorOdd,
  theme
}) => variant === TABLE_VARIANT_TYPES.striped && !stripedColorEven && stripedColorOdd && (0, _stylitas.css)`
    tr:nth-of-type(even) {
      background-color: ${_stylitas.utilities.palette.color(theme, 'neutral00')};
    }

    tr:nth-of-type(odd) {
      background-color: ${_stylitas.utilities.palette.color(theme, stripedColorOdd)};
    }
  `;

exports.tableBodyStripedCustomOdd = tableBodyStripedCustomOdd;